import { useQuery } from '@tanstack/react-query';
import { reportQueueService } from '../../../../application/ReportsQueueService';
import { PendingReportsActionType } from '../../context/pendingReports/actions';
import { usePendingReportsContext } from '../../context/pendingReports/context';

const QUERY_KEY = `pending_sync_reports`;

export const usePendingReports = () => {
  const { pendingReportsState, pendingReportsDispatch } = usePendingReportsContext();

  const { isLoading, isError, isSuccess, refetch } = useQuery(
    [QUERY_KEY],
    () => reportQueueService.getPendingReports(),
    {
      retry: false,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (pendingReports) => {
        pendingReportsDispatch({
          type: PendingReportsActionType.SET_PENDING_REPORTS,
          payload: pendingReports,
        });
      },
    }
  );

  return {
    data: pendingReportsState.pendingReports,
    isLoading,
    isError,
    isSuccess,
    refetch,
  };
};
